import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useTabsWithParams from '../../../hooks/useTabsWithParams';
import { Tab, Tabs } from 'react-bootstrap';

/**
 * CustomTabs widget
 *
 * @version 1.0.0
 * @param {array} contentTabs the tabs data to display of type [{
*       eventKey: string,
        title: string,
        unmountOnExit: boolean | undefined,
        mountOnEnter: boolean | undefined,
        disabled: boolean,
        transition: boolean,
        content: HTML
    }]
 * @param {string} id name of id
 * @param {string} className names of className
 * @param {string} defaultActiveTabId key of default tab selected
 * @param {boolean} withParams store tab selected on params url or not
 */

const CustomTabsWithParams = ({
    contentTabs,
    id,
    className,
    defaultActiveTabId,
    withParams = true
}) => {
    const [key, setKey] = useState(defaultActiveTabId);
    useTabsWithParams({ withParams, tab: key, setTab: setKey, defaultActiveTabId })

    return <Tabs defaultActiveKey={defaultActiveTabId} activeKey={key} onSelect={(k) => setKey(k)}
        id={id} className={className} style={{ flexWrap: "wrap" }}>
        {contentTabs?.map(contentTab => <Tab
            key={contentTab.eventKey}
            eventKey={contentTab.eventKey}
            title={contentTab.title}
            unmountOnExit={contentTab.unmountOnExit}
            mountOnEnter={contentTab.mountOnEnter}
            disabled={contentTab.disabled}
            transition={contentTab.transition}
        >
            {contentTab.content}
        </Tab>)}
    </Tabs>;
}

CustomTabsWithParams.propTypes = {
    contentTabs: PropTypes.array.isRequired,
    id: PropTypes.string,
    className: PropTypes.string,
    defaultActiveTabId: PropTypes.string.isRequired,
    withParams: PropTypes.bool
};

export default CustomTabsWithParams;